import React, { JSX } from 'react';
import * as Types from '../types/types';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requiredUserType?: Types.UserType;
  allowGuests?: boolean;
}

export function ProtectedRoute({
  children,
  fallback = <div>Please log in to access this page.</div>,
  requiredUserType,
  allowGuests = false,
}: ProtectedRouteProps): JSX.Element {
  const { isAuthenticated, isInitializing, user, isGuest } = useAuth();

  if (isInitializing) return <div>Loading...</div>;
  if (!isAuthenticated) return <>{fallback}</>;
  if (isGuest && !allowGuests)
    return <div>Please create an account or log in to access this page.</div>;
  if (requiredUserType && !isGuest && user?.userType !== requiredUserType) {
    return <div>Access denied. Required user type: {requiredUserType}</div>;
  }

  return <>{children}</>;
}
